import { useMutation } from '@tanstack/react-query'

import type { Favorite } from '@/api/@types'
import { Methods } from '@/api/v1/favorites/_setNo@number/_storeCode@string/items'
import { aspidaClient } from '@/lib/aspida'
import { MutationConfig } from '@/lib/react-query'

export type MoveFavoriteItemsDTO = {
  setNo: Favorite['setNo']
  storeCode: Favorite['storeCode']
  data: Methods['post']['reqBody']
}

export const moveFavoriteItems = ({
  setNo,
  storeCode,
  data,
}: MoveFavoriteItemsDTO) => {
  return aspidaClient.v1.favorites
    ._setNo(setNo)
    ._storeCode(storeCode)
    .items.$post({
      body: data,
      query: {
        action: 'move',
      },
    })
}

type UseMoveFavoriteItemsOptions = {
  config?: MutationConfig<typeof moveFavoriteItems>
}

export const useMoveFavoriteItems = ({
  config,
}: UseMoveFavoriteItemsOptions) => {
  return useMutation({
    ...config,
    mutationFn: moveFavoriteItems,
  })
}
